import { DepartamentoModel } from '@/store/catalogos/departamento';
import { Component, ViewChild } from '@angular/core';
import { FormularioDepartamentoComponent } from '../departamentos/formulario-departamento/formulario-departamento.component';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator, MatPaginatorIntl } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { CatalogoDepartamentoService } from '@services/catalogo/catalogoDepartamento.service';
import { MatDialog } from '@angular/material/dialog';
import { Util } from '@/utils/util';
import { properties } from '@/utils/properties';
import { FormularioProveedorComponent } from './formulario-proveedor/formulario-proveedor.component';
import { CatalogoProveedorService } from '@services/catalogo/catalogoProveedor.service';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-proveedor',
  templateUrl: './proveedor.component.html',
  styleUrls: ['./proveedor.component.scss']
})
export class ProveedorComponent {
  PROP = properties;
  displayedColumns: string[] = ['noProveedor', 'razonSocial', 'rfc', 'telefono', 'fax','options'];
  dataSource = new MatTableDataSource<any>([]);
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;

  constructor(
    private paginator1: MatPaginatorIntl,
    private proveedorService: CatalogoProveedorService,
    public dialog: MatDialog,
    private spinner: NgxSpinnerService,
    private util: Util) {
    this.paginator1.itemsPerPageLabel = "Registros por página";
  }

  ngOnInit() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;

    this. loadProveedor();

  }

  filterTable(event: Event) {
    const filtro = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filtro.trim().toLowerCase();
  }

  loadProveedor() {
    this.proveedorService.getAll().subscribe(data => {
      this.dataSource = new MatTableDataSource(data);
      this.dataSource.sort = this.sort;
      this.dataSource.paginator = this.paginator;
    });

  }


  new() {
    const dialogRef = this.dialog.open(FormularioProveedorComponent, {
      width: '80%',
      maxWidth: 'none',
      height: 'auto',
       disableClose: true, data:{insert:true,update:false,view:false,row:null}
    });
    dialogRef.afterClosed().subscribe(result => {
      if (!this.util.isEmpty(result) && result.data.success) {
        this.loadProveedor();
      }
    });
  }

  update(row: DepartamentoModel) {
    const dialogRef = this.dialog.open(FormularioProveedorComponent, {
      width: '80%',
      maxWidth: 'none',
      height: 'auto',
       disableClose: true, data:{insert:false,update:true,view:false,row:row}
    });
    dialogRef.afterClosed().subscribe(result => {
      if (!this.util.isEmpty(result) && result.data.success) {
        this.loadProveedor();
      }
    });
  }

  view(row: DepartamentoModel) {
    const dialogRef = this.dialog.open(FormularioProveedorComponent, {
      width: '80%',
      maxWidth: 'none',
      height: 'auto',
       disableClose: true, data:{insert:false,update:false,view:true,row:row}
    });
    dialogRef.afterClosed().subscribe(result => {
      if (!this.util.isEmpty(result) && result.data.success) {
        this.loadProveedor();
      }
    });
  }

}
